import {AsyncPipe} from '@angular/common';
import {Component, Input, OnInit} from '@angular/core';
import {MatDivider} from '@angular/material/divider';
import {MatList} from '@angular/material/list';
import {MatSidenav} from '@angular/material/sidenav';
import {MatTree, MatTreeNode, MatTreeNodeDef, MatTreeNodePadding,} from '@angular/material/tree';
import {Router} from '@angular/router';
import {Client, ClientService} from '@app/admin/client.service';
import {AssetService} from '@app/asset';
import {InviteUsersButtonComponent} from '@app/invitation/invite-users-button/invite-users-button.component';
import {Stream} from '@app/stream/models';
import {StreamService} from '@app/stream/stream.service';
import {StreamTree} from '@app/stream/streamtree';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';

interface StreamNode {
    expandable: boolean;
    name: string;
    level: number;
    parent: string;
    stream: Stream;
}

@Component({
    selector: 'frog-stream-list',
    templateUrl: './stream-list.component.html',
    styleUrls: ['./stream-list.component.scss'],
    imports: [
        InviteUsersButtonComponent,
        MatDivider,
        MatList,
        MatTree,
        MatTreeNodeDef,
        MatTreeNode,
        MatTreeNodePadding,
        AsyncPipe,
    ],
})
export class StreamListComponent implements OnInit {
    @Input() expandable: boolean = true;
    @Input() add: boolean = true;
    public streams$: Observable<Stream[]>;
    public stream$: Observable<Stream>;
    public client$: Observable<Client>;

    public activeStream: Stream;
    public streamTree: StreamTree;

    constructor(
        private streamService: StreamService,
        private assetService: AssetService,
        private clientService: ClientService,
        private matSideNav: MatSidenav,
        private router: Router,
    ) {
        this.activeStream = null;

        this.streamTree = new StreamTree();
    }

    ngOnInit(): void {
        this.streams$ = this.streamService.streams.pipe(
            map((streams) => streams.filter((stream) => stream.parent === null)),
            map((streams) => streams.sort((a, b) => a.name.localeCompare(b.name))),
            tap((streams) => {
                this.streamTree.dataSource.data = streams;
                this.streamTree.treeControl.expandAll();
            }),
        );
        this.stream$ = this.streamService.stream;
        this.client$ = this.clientService.get();
    }

    hasChild(_: number, node: StreamNode) {
        return node.expandable;
    }

    viewStream(stream: Stream) {
        this.activeStream = stream;
        this.router.navigate([`/s/${stream.id}`]);
        this.matSideNav.close();
    }
}
